import React, { useRef, useState, useEffect } from "react"
import styled from "styled-components"
import { gsap } from "gsap"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import Container from "../layout/container/Container"

const StyledSection = styled(BackgroundImage)`
  display: flex;
  align-items: center;
  margin-top: 122px;
  min-height: calc(100vh - 122px);
  max-height: 1040px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  padding-top: 0;
  padding-bottom: 0;
  @media (max-width: 1024px) {
    margin-top: 120px;
    min-height: calc(100vh - 120px);
    padding-top: 0;
    padding-bottom: 0;
  }
  @media (max-width: 419px) {
    margin-top: 96px;
    min-height: calc(100vh - 96px);
    padding-top: 0;
    padding-bottom: 0;
  }
`
const StyledHeaderWrapper = styled.div`
  padding: 4rem 0;
  text-align: center;
`
const StyledHeading = styled.h1`
  padding-bottom: 40px;
  color: ${props => props.theme.colors.white};
  font-family: ${props => props.theme.fonts.secondary};
  font-size: 6rem;
  text-transform: uppercase;
  @media (max-width: 768px) {
    font-size: 5rem;
  }
  @media (max-width: 489px) {
    font-size: 3.75rem;
    padding-bottom: 20px;
  }
  @media (max-width: 374px) {
    font-size: 3rem;
  }
`
const StyledSubheading = styled.h2`
  color: ${props => props.theme.colors.gold};
  font-family: ${props => props.theme.fonts.secondary};
  font-size: 2rem;
  font-style: italic;
  @media (max-width: 768px) {
    font-size: 1.75rem;
  }
  @media (max-width: 489px) {
    font-size: 1.5rem;
  }
  @media (max-width: 374px) {
    font-size: 1.25rem;
  }
`

export default function HeroSection() {
  const data = useStaticQuery(
    graphql`
      query {
        file(relativePath: { eq: "origin-hero.webp" }) {
          childImageSharp {
            fluid(quality: 90, maxWidth: 1900) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  )

  // Set ImageData.
  const gradientOverlay = `linear-gradient(rgba(30,30,30,0.6), rgba(30,30,30,0.6))`
  const imageData = [gradientOverlay, data.file.childImageSharp.fluid]

  // GSAP
  let headingRef = useRef(null)
  let subheadingRef = useRef(null)
  let headerRef = useRef(null)
  const [heroTL] = useState(
    gsap.timeline({
      defaults: {
        autoAlpha: 0,
      },
    })
  )

  useEffect(() => {
    heroTL
      .from(headingRef.current, {
        y: -100,
        ease: "power1.inOut",
        duration: 1,
      })
      .from(subheadingRef.current, {
        y: 50,
        ease: "power4.inOut",
        duration: 1,
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    gsap.to(headerRef.current, {
      autoAlpha: 0,
      y: -100,
      ease: "sine.out",
      scrollTrigger: {
        trigger: headingRef.current,
        start: "bottom 40%",
        end: "+=45%",
        scrub: true,
      },
    })
  }, [])

  return (
    <StyledSection Tag="section" fluid={imageData} backgroundColor={`#1e1e1e`}>
      <Container>
        <StyledHeaderWrapper ref={headerRef}>
          <StyledHeading ref={headingRef}>Origin</StyledHeading>
          <StyledSubheading ref={subheadingRef}>
            Flavorful chaofan. Juicy sandwiches. Ice-cold drinks.
          </StyledSubheading>
        </StyledHeaderWrapper>
      </Container>
    </StyledSection>
  )
}
